/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row1_CostInputs */

const en_mk_model_row1_cost = /** @type {(inputs: Mk_Model_Row1_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Rp1,200/reply`)
};

const id_mk_model_row1_cost = /** @type {(inputs: Mk_Model_Row1_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≈ Rp1.200/balasan`)
};

/**
* | output |
* | --- |
* | "≈ Rp1,200/reply" |
*
* @param {Mk_Model_Row1_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row1_cost = /** @type {((inputs?: Mk_Model_Row1_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row1_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row1_cost(inputs)
	return en_mk_model_row1_cost(inputs)
});